import React, {Fragment} from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {makeStyles} from "@mui/styles";
import {Input} from "@mui/material";
import {isValidPassword} from "_helpers";
export default function PasswordEntry({ input, label, performAction, meta: { touched, error } }) {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        password: '',
        showPassword: false,
    });
    const hasError = touched && !_.isEmpty(error) && !isValidPassword(values.password);

    const handleChange = (prop) => (event) => {
        const value = event.target.value;
        setValues({ ...values, [prop]: value });
        performAction(value);
    };

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return(
        <Fragment>
            <FormControl sx={{ width: '100%' }} variant={"standard"}>
                <InputLabel htmlFor="password" className={ hasError ? classes.inputLabelError : classes.inputLabel } error={ hasError }>{ label }</InputLabel>
                <Input
                    className={ classes.outlinedInput }
                    id="password"
                    {...input}
                    type={values.showPassword ? 'text' : 'password'}
                    value={values.password}
                    onChange={handleChange('password')}
                    error={ hasError }
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                sx={{mr: '1px', mb: '10px'}}
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {values.showPassword ?
                                    <VisibilityOff sx={{width: '20px', height: '20px'}} /> :
                                    <Visibility sx={{width: '20px', height: '20px'}} />}
                            </IconButton>
                        </InputAdornment>
                    }
                    label="Password"
                />
            </FormControl>
        </Fragment>
    )
}

const useStyles = makeStyles({
    outlinedInput: {
        width: '100%',
        fontSize: '16px !important',
        [`& fieldset`]: {
            border: '1px solid #115d82'
        },
    },
    inputLabel: {
        fontSize: '16px',
        '&.Mui-focused': {
            color: '#115d82'
        }
    },
    inputLabelError: {
        fontSize: '16px',
        color: '#115d82',
        '&.Mui-focused': {
            color: '#EB5757'
        }
    },
});